import React, {FC} from 'react';
import styles from './Loader.module.scss';
import classNames from 'classnames';
import {Text} from '@priority-software/priority-style-react';
import {LoaderAnimation} from './LoaderAnimation';

export interface LoaderProps {
    isVisible?: boolean;
    componentClassname?: string;
    workingLabel?: string;
}

export const Loader: FC<LoaderProps> = ({isVisible, componentClassname, workingLabel}) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className={classNames(styles.wrapper, componentClassname)}>
            <LoaderAnimation />
            {workingLabel && (
                <Text
                    componentClasses={styles.workingLabel}
                    tag={'span'}
                    skin={'paragraph-1'}
                    textColor={'primary-700'}
                >
                    {workingLabel}
                </Text>
            )}
        </div>
    );
};
